import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// ── Icônes ───────────────────────────────────────────────────
const IconMail = ({ size = 22, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const IconPhone = ({ size = 22, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.56 1.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);
const IconPin = ({ size = 22, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);
const IconCheck = ({ size = 20, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const IconSend = ({ size = 18, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);
const IconPartner = ({ size = 22, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const IconSupport = ({ size = 22, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);
const IconInvest = ({ size = 22, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <line x1="12" y1="1" x2="12" y2="23"/>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
  </svg>
);

export default function Contact() {
  const navigate = useNavigate();
  const [sujet, setSujet] = useState("support");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ nom: "", email: "", telephone: "", message: "" });

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });

  const envoyer = e => {
    e.preventDefault();
    if (!form.nom || !form.email || !form.message) return;
    setLoading(true);
    // TODO backend: POST /api/contact
    setTimeout(() => { setLoading(false); setSent(true); }, 1200);
  };

  const sujets = [
    { id: "support", label: "Support client", icon: <IconSupport size={18} color="inherit" />, desc: "Problème avec une réservation, question sur la plateforme" },
    { id: "partenariat", label: "Devenir partenaire", icon: <IconPartner size={18} color="inherit" />, desc: "Inscrire votre hôtel, restaurant ou service" },
    { id: "investissement", label: "Investissement", icon: <IconInvest size={18} color="inherit" />, desc: "Vous souhaitez investir dans SenuTour" },
  ];

  const infos = [
    { icon: <IconMail size={20} color="#C4441A" />, titre: "Email", val: "contact.senutour@gmail.com", sub: "Réponse sous 24h" },
    { icon: <IconPhone size={20} color="#C4441A" />, titre: "Téléphone", val: "+221 78 239 57 22", sub: "Lun–Ven, 8h–18h" },
    { icon: <IconPin size={20} color="#C4441A" />, titre: "Adresse", val: "Dakar, Sénégal", sub: "Siège social" },
  ];

  return (
    <div style={{ fontFamily: "'Fraunces', serif", background: "#FAF5EC", color: "#1C1008", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@400;500;600;700&display=swap');
        * { margin:0; padding:0; box-sizing:border-box; }

        .form-input {
          width: 100%; padding: 13px 16px;
          border: 1.5px solid #E8DCC8; border-radius: 8px;
          font-family: 'Space Grotesk', sans-serif; font-size: 14px;
          color: #1C1008; background: white; outline: none; transition: all .25s;
        }
        .form-input:focus { border-color: #C4441A; box-shadow: 0 0 0 3px rgba(196,68,26,.08); }
        .form-input::placeholder { color: #C4B8A8; }

        .sujet-btn {
          display: flex; align-items: flex-start; gap: 12px;
          padding: 16px 18px; border-radius: 12px; cursor: pointer;
          border: 2px solid #E8DCC8; background: white; transition: all .25s;
          width: 100%; text-align: left;
        }
        .sujet-btn.active { border-color: #C4441A; background: rgba(196,68,26,.03); color: #C4441A; }
        .sujet-btn:hover:not(.active) { border-color: rgba(196,68,26,.3); }

        .btn-send {
          width: 100%; padding: 15px; background: #C4441A; color: white;
          border: none; border-radius: 10px;
          font-family: 'Space Grotesk', sans-serif; font-size: 16px; font-weight: 700;
          cursor: pointer; transition: all .3s;
          display: flex; align-items: center; justify-content: center; gap: 10px;
        }
        .btn-send:hover:not(:disabled) { background: #A03614; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(196,68,26,.3); }
        .btn-send:disabled { opacity: .55; cursor: not-allowed; transform: none; }

        @keyframes fadeUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
        .fade-up { animation: fadeUp .6s ease forwards; }

        @keyframes scaleIn { from { opacity:0; transform:scale(.85); } to { opacity:1; transform:scale(1); } }
        .scale-in { animation: scaleIn .5s ease forwards; }

        @keyframes spin { to { transform: rotate(360deg); } }

        @media(max-width:900px) { .contact-grid { grid-template-columns: 1fr !important; } }
        @media(max-width:767px) { .contact-pad { padding: 40px 5% 60px !important; } }
      `}</style>

      <Navbar transparent={false} />

      {/* ── HERO ─────────────────────────────────────────────── */}
   <section style={{ 
  background: "linear-gradient(135deg, #1C1008 0%, #2D1A08 100%)", 
  padding: "100px 5% 56px",   // ← le paddingTop:68 était inutile ici
  position: "relative", 
  overflow: "hidden" 
}}>
        <div style={{ position:"absolute", inset:0, backgroundImage:"url(https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=1200&q=60)", backgroundSize:"cover", backgroundPosition:"center", opacity:.08 }} />
        <div style={{ position:"absolute", width:360, height:360, borderRadius:"50%", background:"#C4441A", top:-80, right:-60, filter:"blur(80px)", opacity:.15 }} />
        <div style={{ maxWidth:1100, margin:"0 auto", position:"relative", zIndex:1 }}>
          <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, fontWeight:700, letterSpacing:3, color:"#C4441A", textTransform:"uppercase", marginBottom:12 }}>
            Contactez-nous
          </p>
          <h1 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(30px,5vw,58px)", fontWeight:800, color:"white", lineHeight:1.1, letterSpacing:"-1.5px", marginBottom:16, maxWidth:700 }}>
            Parlons de votre projet avec{" "}
            <span style={{ color:"#E8834A", fontStyle:"italic" }}>SenuTour</span>
          </h1>
          <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:16, color:"rgba(255,255,255,.6)", maxWidth:520, lineHeight:1.75 }}>
            Touriste, partenaire ou investisseur — nous sommes là pour vous répondre dans les 24 heures.
          </p>
        </div>
      </section>

      <section className="contact-pad" style={{ padding: "56px 5% 80px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>

          {/* ── CONFIRMATION ENVOI ── */}
          {sent && (
            <div className="scale-in" style={{ textAlign: "center", padding: "80px 20px", background: "white", borderRadius: 20, border: "1.5px solid rgba(61,107,46,.2)", boxShadow: "0 12px 40px rgba(28,16,8,.08)", marginBottom: 40 }}>
              <div style={{ width: 72, height: 72, borderRadius: "50%", background: "#3D6B2E", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", boxShadow: "0 10px 28px rgba(61,107,46,.3)" }}>
                <IconCheck size={32} color="white" />
              </div>
              <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 32, fontWeight: 800, marginBottom: 12 }}>Message envoyé !</h2>
              <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 15, color: "#7A5A3A", marginBottom: 28, maxWidth: 420, margin: "0 auto 28px" }}>
                Merci <strong>{form.nom}</strong> ! Nous avons bien reçu votre message et vous répondrons sous 24h à <strong>{form.email}</strong>.
              </p>
              <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
                <button onClick={() => navigate("/")} style={{ background: "#C4441A", color: "white", border: "none", padding: "12px 28px", borderRadius: 8, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
                  Retour à l'accueil
                </button>
                <button onClick={() => { setSent(false); setForm({ nom:"", email:"", telephone:"", message:"" }); }}
                  style={{ background: "transparent", border: "1.5px solid rgba(28,16,8,.2)", color: "#1C1008", padding: "12px 24px", borderRadius: 8, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
                  Envoyer un autre message
                </button>
              </div>
            </div>
          )}

          {!sent && (
            <div className="contact-grid" style={{ display: "grid", gridTemplateColumns: "1fr 380px", gap: 40, alignItems: "start" }}>

              {/* ── FORMULAIRE ── */}
              <div className="fade-up">
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 26, fontWeight: 800, marginBottom: 24, letterSpacing: "-0.5px" }}>
                  Envoyez-nous un message
                </h2>

                {/* Choix du sujet */}
                <div style={{ marginBottom: 28 }}>
                  <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, color: "#1C1008", textTransform: "uppercase", letterSpacing: 1, marginBottom: 12 }}>
                    Sujet de votre demande
                  </p>
                  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {sujets.map(s => (
                      <button key={s.id} className={`sujet-btn ${sujet === s.id ? "active" : ""}`} onClick={() => setSujet(s.id)}>
                        <div style={{ color: sujet === s.id ? "#C4441A" : "#7A5A3A", flexShrink: 0, marginTop: 1 }}>
                          {s.icon}
                        </div>
                        <div>
                          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, color: sujet === s.id ? "#C4441A" : "#1C1008", marginBottom: 2 }}>
                            {s.label}
                          </div>
                          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#B8A898" }}>
                            {s.desc}
                          </div>
                        </div>
                        <div style={{ marginLeft: "auto", width: 20, height: 20, borderRadius: "50%", border: `2px solid ${sujet === s.id ? "#C4441A" : "#E8DCC8"}`, background: sujet === s.id ? "#C4441A" : "white", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                          {sujet === s.id && <div style={{ width: 8, height: 8, borderRadius: "50%", background: "white" }} />}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Formulaire */}
                <form onSubmit={envoyer}>
                  <div style={{ background: "white", borderRadius: 14, padding: "28px", border: "1.5px solid rgba(28,16,8,.06)", marginBottom: 16 }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
                      <div>
                        <label style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#1C1008", display: "block", marginBottom: 7, textTransform: "uppercase", letterSpacing: 1 }}>Nom complet *</label>
                        <input className="form-input" name="nom" placeholder="Amina Diallo" value={form.nom} onChange={handle} required />
                      </div>
                      <div>
                        <label style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#1C1008", display: "block", marginBottom: 7, textTransform: "uppercase", letterSpacing: 1 }}>Téléphone</label>
                        <input className="form-input" name="telephone" placeholder="+221 77 000 00 00" value={form.telephone} onChange={handle} />
                      </div>
                    </div>

                    <div style={{ marginBottom: 16 }}>
                      <label style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#1C1008", display: "block", marginBottom: 7, textTransform: "uppercase", letterSpacing: 1 }}>Email *</label>
                      <input className="form-input" type="email" name="email" placeholder="votre@email.com" value={form.email} onChange={handle} required />
                    </div>

                    <div>
                      <label style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#1C1008", display: "block", marginBottom: 7, textTransform: "uppercase", letterSpacing: 1 }}>Message *</label>
                      <textarea className="form-input" name="message" placeholder={
                        sujet === "partenariat" ? "Décrivez votre établissement, votre ville et vos services..."
                        : sujet === "investissement" ? "Parlez-nous de votre projet d'investissement..."
                        : "Décrivez votre problème ou votre question..."
                      } value={form.message} onChange={handle} rows={5} required style={{ resize: "vertical" }} />
                    </div>
                  </div>

                  <button className="btn-send" type="submit" disabled={loading || !form.nom || !form.email || !form.message}>
                    {loading
                      ? <span style={{ width: 18, height: 18, border: "2px solid rgba(255,255,255,.3)", borderTopColor: "white", borderRadius: "50%", display: "inline-block", animation: "spin .8s linear infinite" }} />
                      : <><IconSend size={16} color="white" /> Envoyer le message</>
                    }
                  </button>
                </form>
              </div>

              {/* ── INFOS DROITE ── */}
              <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

                {/* Coordonnées */}
                <div style={{ background: "white", borderRadius: 16, padding: "28px", border: "1.5px solid rgba(28,16,8,.08)" }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 700, marginBottom: 20 }}>
                    Nos coordonnées
                  </h3>
                  <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                    {infos.map((info, i) => (
                      <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                        <div style={{ width: 42, height: 42, borderRadius: 10, background: "rgba(196,68,26,.08)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                          {info.icon}
                        </div>
                        <div>
                          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#B8A898", textTransform: "uppercase", letterSpacing: 1, marginBottom: 3 }}>{info.titre}</div>
                          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, color: "#1C1008", marginBottom: 2 }}>{info.val}</div>
                          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#B8A898" }}>{info.sub}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Partenaire CTA */}
                <div style={{ background: "linear-gradient(135deg, #1C1008 0%, #2D1A08 100%)", borderRadius: 16, padding: "28px", position: "relative", overflow: "hidden" }}>
                  <div style={{ position:"absolute", width:200, height:200, borderRadius:"50%", background:"#C4441A", top:-60, right:-60, filter:"blur(60px)", opacity:.2 }} />
                  <div style={{ position:"relative", zIndex:1 }}>
                    <div style={{ width: 44, height: 44, borderRadius: 10, background: "rgba(196,68,26,.2)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 14 }}>
                      <IconPartner size={22} color="#E8834A" />
                    </div>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 700, color: "white", marginBottom: 8 }}>
                      Devenez partenaire
                    </h3>
                    <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "rgba(255,255,255,.55)", lineHeight: 1.65, marginBottom: 18 }}>
                      Inscrivez votre hôtel, restaurant ou service gratuitement et accédez à des milliers de touristes.
                    </p>
                    <button onClick={() => navigate("/inscription")}
                      style={{ background: "#C4441A", color: "white", border: "none", padding: "11px 20px", borderRadius: 8, fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 600, cursor: "pointer", width: "100%", transition: "all .3s" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#A03614"}
                      onMouseLeave={e => e.currentTarget.style.background = "#C4441A"}>
                      S'inscrire gratuitement →
                    </button>
                  </div>
                </div>

                {/* FAQ rapide */}
                <div style={{ background: "#F0E8D4", borderRadius: 16, padding: "24px 26px", border: "1px solid rgba(196,68,26,.1)" }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 700, marginBottom: 16 }}>
                    Questions fréquentes
                  </h3>
                  {[
                    { q: "Comment annuler une réservation ?", r: "Gratuit sous 24h après la réservation." },
                    { q: "Comment inscrire mon établissement ?", r: "Créez un compte et choisissez 'Établissement'." },
                    { q: "Quels modes de paiement sont acceptés ?", r: "Wave, Orange Money et carte bancaire." },
                  ].map((faq, i) => (
                    <div key={i} style={{ marginBottom: i < 2 ? 14 : 0, paddingBottom: i < 2 ? 14 : 0, borderBottom: i < 2 ? "1px solid rgba(28,16,8,.08)" : "none" }}>
                      <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, color: "#1C1008", marginBottom: 4 }}>{faq.q}</div>
                      <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#7A5A3A" }}>{faq.r}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}